import { useEffect, useState } from "react";
import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import { Typography } from "components/atoms/Typography";
import { Button } from "components/atoms/Button";
import { Label } from "components/atoms";
import { useScreenSize } from "hooks";
import { TAB_WIDTH, MOBILE_WIDTH } from "utils/constants";
import "./index.scss";
import { ButtonsByContentObjectTypes } from "../ButtonsByContentObjectTypes";


interface IProps {
  index: number;
  textIconLabel: string;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock";
  // btnLabel: string;
  middleLabel?: string | null;
  isBtn?: boolean;
  // isSecondBtn?: boolean;
  // secondBtnLabel?: string;
  handlePrimaryBtnClick?: () => any;
  handleSecondaryBtnClick?: () => any;
  theme: "light" | "dark";
  // segmentType: any;
  status: string;
  contentObjectType: any;
  isLocked: boolean;
  badge?: string;
  drillSmartResult?: any; // DrillSmartResult object for DrillSmart items
}

export const SelfPacedHomeWorkRow = ({
  index,
  textIconLabel,
  iconType,
  // btnLabel,
  middleLabel,
  // isSecondBtn,
  // secondBtnLabel,
  isBtn,
  theme,
  // segmentType,
  status,
  contentObjectType,
  isLocked,
  badge,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
  drillSmartResult,
}: IProps) => {
  const [responsiveMiddleLabel, setResponsiveMiddleLabel] = useState("");

  useEffect(() => {
    if (middleLabel && middleLabel.length > 5) {
      setResponsiveMiddleLabel(middleLabel.slice(0, 5) + "...");
    }
  }, []);

  const screen = useScreenSize();

  return (
    <div
      className={classNames(
        "self-paced-home-work-row-wrapper",
        {
          "bg-white": index % 2 === 0,
          "bg-blue": index % 2 !== 0,
          "bg-gray": iconType === "lock",
        },
        screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH
          ? "tab-style"
          : ""
      )}
    >
      {screen.width <= 1550 ? (
        <div className="home-tab-size-wrapper">
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <TextIcon
              label={textIconLabel}
              badge={badge}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <TextIcon
              label={textIconLabel}
              badge={badge}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </>
      )}

      <div
        className={classNames(
          "btn-section",
          screen.width <= 810 || (screen.width > 1024 && screen.width < 1226)
            ? "course-index-tab-btn-handle"
            : ""
        )}
      >
        {/* {isSecondBtn && (
          <Button
            type="online"
            icon={false}
            label={secondBtnLabel}
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handleSecondaryBtnClick}
          />
        )}

        {isBtn && (
          <Button
            type="score"
            icon={false}
            label={btnLabel}
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        )} */}
        <ButtonsByContentObjectTypes
          status={status}
          isLocked={isLocked}
          contentObjectType={contentObjectType}
          handlePrimaryBtnClick={handlePrimaryBtnClick}
          handleSecondaryBtnClick={handleSecondaryBtnClick}
          drillSmartResult={drillSmartResult}
        />
      </div>
    </div>
  );
};
